import { Link } from "react-router-dom";
import { Scale, ArrowUpRight } from "lucide-react";
import { toggleCompare, isInCompare } from "../lib/compareStore";
import { toast } from "sonner";
import { useState, useEffect } from "react";

export default function ProductCard({ product, onAddToQuote }) {
  const [inCompare, setInCompare] = useState(false);
  useEffect(() => {
    setInCompare(isInCompare(product.id));
    const h = () => setInCompare(isInCompare(product.id));
    window.addEventListener("compare:update", h);
    return () => window.removeEventListener("compare:update", h);
  }, [product.id]);

  const badgeLabels = {
    premium: "Premium",
    logo_baskili: "Logo Baskılı",
    toptan: "Toptan",
    stokta: "Stokta",
  };

  return (
    <div className="card-premium group overflow-hidden flex flex-col" data-testid={`product-card-${product.slug}`}>
      <Link to={`/urun/${product.slug}`} className="relative block aspect-[4/3] overflow-hidden bg-softbg">
        {product.images?.[0] && (
          <img
            src={product.images[0]}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        )}
        <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
          {(product.badges || []).slice(0, 2).map((b) => (
            <span key={b} className={`badge-${b === "logo_baskili" ? "logo" : b === "toptan" ? "toptan" : b === "stokta" ? "stock" : "premium"}`}>
              {badgeLabels[b] || b}
            </span>
          ))}
        </div>
      </Link>
      <div className="p-5 flex flex-col flex-1">
        <Link to={`/urun/${product.slug}`} className="block">
          <h3 className="font-serif text-lg font-semibold text-navy group-hover:text-gold transition-colors leading-snug mb-1">
            {product.name}
          </h3>
        </Link>
        <p className="text-[13px] text-gray-600 line-clamp-2 flex-1">{product.short_description}</p>
        <div className="mt-4 flex items-center justify-between">
          <span className="text-[11px] uppercase tracking-wider text-gray-500">
            Min. Sipariş: <span className="text-navy font-medium">{product.min_order}</span>
          </span>
        </div>
        <div className="mt-4 flex items-center gap-2">
          <Link
            to={`/urun/${product.slug}`}
            className="btn-gold !py-2 !px-4 text-xs flex-1 justify-center"
            data-testid={`product-card-quote-${product.slug}`}
          >
            Teklif Al <ArrowUpRight size={14} />
          </Link>
          <button
            onClick={() => {
              toggleCompare(product);
              toast.success(inCompare ? "Karşılaştırmadan çıkarıldı" : "Karşılaştırmaya eklendi");
            }}
            className={`h-9 w-9 rounded-md border flex items-center justify-center transition-colors ${
              inCompare
                ? "bg-teal text-white border-teal"
                : "border-gray-200 text-gray-500 hover:border-teal hover:text-teal"
            }`}
            aria-label="Karşılaştır"
            data-testid={`product-card-compare-${product.slug}`}
          >
            <Scale size={15} />
          </button>
        </div>
      </div>
    </div>
  );
}
